import React from 'react';

import { Box } from '@lightspeed/flame/Core';

import { translate } from 'pages/utils/translate';
import {
  CalendarBody,
  CalendarHeader,
  CountdownNumber,
  DaysLeftText,
  RingHole,
  RingHoleBlack,
  RingHoleWhite,
  StyledCountdownCalendar as StyledCalendar,
} from 'pages/views/reports/CustomerData/BannerOffendingRecordsDetected/styles/StyledCountdownCalendar.style';

interface StyledCountdownCalendarProps {
  daysFromNow: number | null;
}

const StyledCountdownCalendar: React.FC<StyledCountdownCalendarProps> = ({ daysFromNow }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      <StyledCalendar>
        {/* Calendar body - white rectangle with shadow */}
        <CalendarBody />

        {/* Calendar header - red rectangle */}
        <CalendarHeader />

        {/* Ring holes - left */}
        <RingHole style={{ left: '27px' }}>
          <RingHoleWhite />
          <RingHoleBlack />
        </RingHole>

        {/* Ring holes - center */}
        <RingHole style={{ left: '70px' }}>
          <RingHoleWhite />
          <RingHoleBlack />
        </RingHole>

        {/* Ring holes - right */}
        <RingHole style={{ left: '112px' }}>
          <RingHoleWhite />
          <RingHoleBlack />
        </RingHole>

        {/* Countdown number */}
        <CountdownNumber>{daysFromNow}</CountdownNumber>

        {/* "Days left!" text */}
        <DaysLeftText>
          {daysFromNow === 1 ? translate('Day left!') : translate('Days left!')}
        </DaysLeftText>
      </StyledCalendar>
    </Box>
  );
};

export default StyledCountdownCalendar;
